import { useState } from 'react';
import { useDonationBlockProps } from '../DonationBlockProvider';
import { useDonationNavigation } from '../libs/useDonationNavigation';
import { useBamboraContext } from './useBamboraContext';

interface BamboraPaymentApiResult {
    success: boolean;
    message: string;
    iframeUrl: string;
}

interface useIPGPaymentResult {
    isLoading: boolean;
    getIframeURL: (submissionId: string) => Promise<void>;
}

const useBamboraPayment = (): useIPGPaymentResult => {
    const [isLoading, setIsLoading] = useState(false);

    const { baseURL } = useDonationBlockProps();
    const { nextStep } = useDonationNavigation();
    const { setIframeURL: updateBamboraIframeURL } = useBamboraContext();

    const getIframeURL = async(submissionId: string): Promise<void> => {
        // set loading status
        setIsLoading(true);

        try {
            const formdata = new FormData();
            formdata.append('SubmissionId', submissionId);
            formdata.append('IsDonorUpdate', 'false');

            const request = await fetch(`${baseURL}/api/Bambora/newiframe`, {
                method: 'POST',
                body: formdata,
            });

            if (!request.ok) {
                throw new Error('Failed to connect to API');
            }

            const result: BamboraPaymentApiResult = await request.json();

            if (!result.success) {
                throw new Error('Failed to generate payment url');
            }

            // update ipg payment data
            updateBamboraIframeURL(result.iframeUrl);
            // console.debug('iframe url: ', result.iframeUrl);

            // go to the next step
            nextStep();
        } catch (error) {
            console.error('[Bambora] ', error);
            throw error;
        }

        // reset loading status
        setIsLoading(false);
    };


    return { isLoading, getIframeURL };
};

export default useBamboraPayment;
